(() => {
  function boot() {
    const marker = document.querySelector('[data-lcg-clone]');
    if (!marker || marker.dataset.ready) return;
    marker.dataset.ready = 'true';
    const main = marker.closest('[id^="MainProduct-"]');
    if (!main) return;
    const observedFloatingButtons = new WeakSet();
    function styleBuyButtons() {
      // Releasit reapplies inline !important styles after its buttons load.
      const styles = {background: '#d93620', color: '#fff', 'border-color': '#d93620', 'border-width': '1px', 'border-radius': '7px', 'min-height': '56px', 'box-shadow': 'none'};
      document.querySelectorAll('#_rsi-buy-now-button, ._rsi-buy-now-button').forEach(button => {
        const subtitle = button.querySelector('._rsi-buy-now-button-subtitle');
        if (subtitle && subtitle.textContent.trim() !== 'Pagamento na entrega') subtitle.textContent = 'Pagamento na entrega';
        const inMain = main.contains(button);
        if (!inMain && !button.closest('#_rsi-buy-now-button-floating, ._rsi-buy-now-button-floating')) return;
        if (!inMain && !observedFloatingButtons.has(button)) {
          observedFloatingButtons.add(button);
          new MutationObserver(styleBuyButtons).observe(button, {attributes: true, attributeFilter: ['style']});
        }
        for (const [name, value] of Object.entries(styles)) {
          if (!inMain && !['background', 'color', 'border-color'].includes(name)) continue;
          const current = button.style.getPropertyValue(name);
          const expected = name === 'background' || name === 'border-color' ? 'rgb(217, 54, 32)' : name === 'color' ? 'rgb(255, 255, 255)' : value;
          if (current !== expected || button.style.getPropertyPriority(name) !== 'important') button.style.setProperty(name, value, 'important');
        }
      });
    }
    styleBuyButtons();
    new MutationObserver(styleBuyButtons).observe(main, {subtree: true, childList: true, attributes: true, attributeFilter: ['style']});
    new MutationObserver(styleBuyButtons).observe(document.body, {subtree: true, childList: true});
    main.querySelectorAll('input[name="quantity"]').forEach(input => {
      input.setAttribute('aria-label', `${input.value} packs`);
    });
    document.addEventListener('click', event => {
      const anchor = event.target.closest('a[href="#lcg-buy"]');
      if (!anchor) return;
      const target = document.getElementById('lcg-buy');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center'});
      const radio = main.querySelector('input[name="quantity"]:checked');
      if (radio) radio.focus({preventScroll: true});
    });
    const sticky = document.querySelector('[data-lcg-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(entries => sticky.classList.toggle('is-hidden', entries[0].isIntersecting), {threshold: .15}).observe(main);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
